import React, { useState, useEffect, useRef } from 'react'

const componentStyles = {
    root: {
        display: 'flex',
        flexDirection: 'row',
    }
}

export default function HStack(props) {
    const {
        grow,
        styles = {},
        stackRef,
        children,
    } = props

    const rootStyle = {
        ...componentStyles.root, 
        flexGrow: grow ? grow : null,
        ...styles.root,
    }

    return (
        <div ref={stackRef} style={rootStyle}>
            {children}
        </div>
    )
}